export const FALLBACK_COURSES = {
  coding: [
    {
      id: "fcc-web-design",
      title: "Responsive Web Design Certification",
      platform: "freeCodeCamp",
      url: "https://www.freecodecamp.org/learn/2022/responsive-web-design/",
      pic: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500&q=80",
      rating: "4.9",
      org_price: "Free",
      duration: "300",
      category: "Web Development"
    },
    {
      id: "cs50-intro",
      title: "CS50: Introduction to Computer Science",
      platform: "Harvard / edX",
      url: "https://www.edx.org/course/introduction-to-computer-science-harvardx-cs50x",
      pic: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=500&q=80",
      rating: "4.8",
      org_price: "Free",
      duration: "120",
      category: "Computer Science"
    },
    {
      id: "udemy-web-bootcamp",
      title: "The Complete 2024 Web Development Bootcamp",
      platform: "Udemy (Angela Yu)",
      url: "https://www.udemy.com/course/the-complete-web-development-bootcamp/",
      pic: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=500&q=80",
      rating: "4.7",
      org_price: "$84.99",
      duration: "65",
      category: "Web Development"
    }
  ],
  problem_solving: [
    {
      id: "neetcode",
      title: "DSA Roadmap & LeetCode Solutions",
      platform: "NeetCode",
      url: "https://neetcode.io/roadmap",
      pic: "https://images.unsplash.com/photo-1509228468518-180dd4864904?w=500&q=80",
      rating: "4.9",
      org_price: "Free",
      duration: "100",
      category: "Algorithms"
    },
    {
      id: "takeuforward",
      title: "Striver's SDE Sheet & A2Z Course",
      platform: "Take U Forward",
      url: "https://takeuforward.org/strivers-a2z-dsa-course/strivers-a2z-dsa-course-sheet-2/",
      pic: "https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=500&q=80",
      rating: "4.9",
      org_price: "Free",
      duration: "200",
      category: "Interview Prep"
    },
    {
      id: "educative-grokking",
      title: "Grokking the Coding Interview",
      platform: "Educative",
      url: "https://www.educative.io/courses/grokking-the-coding-interview",
      pic: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500&q=80",
      rating: "4.7",
      org_price: "Subscription",
      duration: "40",
      category: "Algorithms"
    }
  ],
  ai_ml: [
    {
      id: "andrew-ng-ml",
      title: "Machine Learning Specialization",
      platform: "Coursera / DeepLearning.AI",
      url: "https://www.coursera.org/specializations/machine-learning-introduction",
      pic: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=500&q=80",
      rating: "4.9",
      org_price: "Audit for Free",
      duration: "60",
      category: "Artificial Intelligence"
    },
    {
      id: "fast-ai",
      title: "Practical Deep Learning for Coders",
      platform: "Fast.ai",
      url: "https://course.fast.ai/",
      pic: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=500&q=80",
      rating: "4.8",
      org_price: "Free",
      duration: "80",
      category: "Deep Learning"
    },
    {
      id: "udacity-ai",
      title: "AI Programming with Python",
      platform: "Udacity",
      url: "https://www.udacity.com/course/ai-programming-with-python-nanodegree--nd089",
      pic: "https://images.unsplash.com/photo-1527477396000-e27163b481c2?w=500&q=80",
      rating: "4.6",
      org_price: "Paid",
      duration: "90",
      category: "AI Engineering"
    }
  ],
  design: [
    {
      id: "google-ux",
      title: "Google UX Design Professional Certificate",
      platform: "Coursera",
      url: "https://www.coursera.org/professional-certificates/google-ux-design",
      pic: "https://images.unsplash.com/photo-1586717791821-3f44a563eb4c?w=500&q=80",
      rating: "4.8",
      org_price: "Audit for Free",
      duration: "180",
      category: "UI/UX Design"
    },
    {
      id: "figma-basics",
      title: "Figma for Beginners",
      platform: "Official Figma YouTube",
      url: "https://www.youtube.com/playlist?list=PLXDU_eVOJTx7QHLShNqIXL1Cgbxj7HlNn",
      pic: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=500&q=80",
      rating: "4.9",
      org_price: "Free",
      duration: "10",
      category: "Design Tools"
    },
    {
      id: "ixdf",
      title: "User Experience: The Ultimate Guide",
      platform: "Interaction Design Foundation",
      url: "https://www.interaction-design.org/courses/user-experience-the-beginner-s-guide",
      pic: "https://images.unsplash.com/photo-1558655146-d09347e92766?w=500&q=80",
      rating: "4.7",
      org_price: "Membership",
      duration: "30",
      category: "UX Principles"
    }
  ],
  marketing: [
    {
      id: "google-marketing",
      title: "Fundamentals of Digital Marketing",
      platform: "Google Digital Garage",
      url: "https://skillshop.exceedlms.com/student/path/13783-fundamentals-of-digital-marketing",
      pic: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&q=80",
      rating: "4.8",
      org_price: "Free",
      duration: "40",
      category: "Marketing"
    },
    {
      id: "hubspot-content",
      title: "Content Marketing Certification",
      platform: "HubSpot Academy",
      url: "https://academy.hubspot.com/courses/content-marketing",
      pic: "https://images.unsplash.com/photo-1432888622747-4eb9a8f2c1d1?w=500&q=80",
      rating: "4.7",
      org_price: "Free",
      duration: "8",
      category: "Content Strategy"
    },
    {
      id: "meta-smm",
      title: "Meta Social Media Marketing",
      platform: "Coursera / Meta",
      url: "https://www.coursera.org/professional-certificates/facebook-social-media-marketing",
      pic: "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?w=500&q=80",
      rating: "4.8",
      org_price: "Audit for Free",
      duration: "120",
      category: "Social Media"
    }
  ],
  data: [
    {
      id: "google-data",
      title: "Google Data Analytics Professional Certificate",
      platform: "Coursera",
      url: "https://www.coursera.org/professional-certificates/google-data-analytics",
      pic: "https://images.unsplash.com/photo-1551288049-bbdac8626ad1?w=500&q=80",
      rating: "4.8",
      org_price: "Audit for Free",
      duration: "180",
      category: "Data Analytics"
    },
    {
      id: "alex-analyst",
      title: "Data Analyst Bootcamp",
      platform: "Alex The Analyst (YouTube)",
      url: "https://www.youtube.com/playlist?list=PLUaB-1hjhk8H48Pj32z4GZgGWyylqv9jS",
      pic: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=500&q=80",
      rating: "4.9",
      org_price: "Free",
      duration: "50",
      category: "Data Science"
    },
    {
      id: "datacamp-intro",
      title: "Introduction to Python for Data Science",
      platform: "DataCamp",
      url: "https://www.datacamp.com/courses/intro-to-python-for-data-science",
      pic: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=500&q=80",
      rating: "4.7",
      org_price: "Subscription",
      duration: "4",
      category: "Python"
    }
  ],
  cloud: [
    {
      id: "aws-practitioner",
      title: "AWS Cloud Practitioner Essentials",
      platform: "Amazon Web Services",
      url: "https://explore.skillbuilder.aws/learn/course/external/view/elearning/134/aws-cloud-practitioner-essentials",
      pic: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=500&q=80",
      rating: "4.8",
      org_price: "Free",
      duration: "6",
      category: "Cloud"
    },
    {
      id: "azure-fundamentals",
      title: "Microsoft Azure Fundamentals (AZ-900)",
      platform: "Microsoft Learn",
      url: "https://learn.microsoft.com/en-us/training/paths/microsoft-azure-fundamentals-describe-cloud-concepts/",
      pic: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=500&q=80",
      rating: "4.7",
      org_price: "Free",
      duration: "12",
      category: "Azure"
    },
    {
      id: "acloudguru",
      title: "Total Cloud Certification Bundle",
      platform: "A Cloud Guru",
      url: "https://www.pluralsight.com/cloud-guru",
      pic: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=500&q=80",
      rating: "4.8",
      org_price: "Paid",
      duration: "200",
      category: "Cloud & DevOps"
    }
  ],
  security: [
    {
      id: "tryhackme",
      title: "Introduction to Cybersecurity",
      platform: "TryHackMe",
      url: "https://tryhackme.com/path/outline/introtocyber",
      pic: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=500&q=80",
      rating: "4.9",
      org_price: "Free",
      duration: "20",
      category: "Ethical Hacking"
    },
    {
      id: "google-cyber",
      title: "Google Cybersecurity Professional Certificate",
      platform: "Coursera",
      url: "https://www.coursera.org/professional-certificates/google-cybersecurity",
      pic: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=500&q=80",
      rating: "4.8",
      org_price: "Audit for Free",
      duration: "150",
      category: "Cybersecurity"
    },
    {
      id: "cybrary-it",
      title: "IT & Cybersecurity Training",
      platform: "Cybrary",
      url: "https://www.cybrary.it/",
      pic: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=500&q=80",
      rating: "4.6",
      org_price: "Free Tier",
      duration: "100",
      category: "Security"
    }
  ]
};

export const getFallbackCourses = (topic) => {
  if (!topic) return [];
  const normalized = topic.toLowerCase();
  
  if (normalized.includes("web") || normalized.includes("developer") || normalized.includes("coding") || normalized.includes("software") || normalized.includes("frontend") || normalized.includes("backend") || normalized.includes("full stack")) {
    return FALLBACK_COURSES.coding;
  }
  if (normalized.includes("algorithm") || normalized.includes("dsa") || normalized.includes("problem") || normalized.includes("competitive")) {
    return FALLBACK_COURSES.problem_solving;
  }
  if (normalized.includes("ai") || normalized.includes("artificial") || normalized.includes("machine") || normalized.includes("learning") || normalized.includes("deep") || normalized.includes("neural")) {
    return FALLBACK_COURSES.ai_ml;
  }
  if (normalized.includes("design") || normalized.includes("ux") || normalized.includes("ui") || normalized.includes("product")) {
    return FALLBACK_COURSES.design;
  }
  if (normalized.includes("market") || normalized.includes("seo") || normalized.includes("social") || normalized.includes("ad")) {
    return FALLBACK_COURSES.marketing;
  }
  if (normalized.includes("data") || normalized.includes("analyst") || normalized.includes("science")) {
    return FALLBACK_COURSES.data;
  }
  if (normalized.includes("cloud") || normalized.includes("aws") || normalized.includes("azure") || normalized.includes("devops")) {
    return FALLBACK_COURSES.cloud;
  }
  if (normalized.includes("security") || normalized.includes("cyber") || normalized.includes("hacking") || normalized.includes("network")) {
    return FALLBACK_COURSES.security;
  }
  
  // Default to coding if no match
  return FALLBACK_COURSES.coding;
};
